import { Controller, useFormContext } from 'react-hook-form';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import { Select, FormControl, FormHelperText, Checkbox, OutlinedInput } from '@mui/material';
import { FormError } from './hook-form-error';

export interface SelectFieldOption {
    value: any;
    label: string;
    isDefault?: boolean;
}

interface SelectFieldProps {
    options: SelectFieldOption[];
    label: string;
    name: string;
    selectInfo?: string;
    onChange?: (value: any) => void;
    disabled?: boolean;
    className?: string;
    required?: boolean;
}

export const FormCheckboxSelect = ({
    name,
    label,
    options,
    selectInfo,
    onChange = () => {},
    disabled,
    className,
    required,
}: SelectFieldProps): JSX.Element => {
    const { control } = useFormContext();

    return (
        <div className="select">
            <Controller
                control={control}
                name={name}
                defaultValue={[]}
                render={({ field }) => (
                    <FormControl fullWidth disabled={disabled}>
                        <InputLabel size="small" id={`${name}-select-label`}>
                            {label}
                        </InputLabel>
                        <Select
                            multiple
                            size="small"
                            labelId={`${name}-multiple-checkbox-label`}
                            id={`${name}-multiple-checkbox`}
                            value={field.value || []}
                            onChange={(e) => {
                                field.onChange(e.target.value);
                                onChange(e.target.value);
                            }}
                            input={<OutlinedInput label={label} />}
                            renderValue={(selected: any[]) =>
                                selected.map(
                                    (val) => options.find((opt) => opt.value === val)?.label || val
                                ).join(', ')
                            }
                            className={`${className} ${required ? 'itsarequiredField' : ''} ${
                                field.value?.length ? 'has-data' : ''
                            }`}
                        >
                            {options.map((o) => (
                                <MenuItem key={`${name}-${o.value}`} value={o.value}>
                                    <Checkbox checked={field.value?.includes(o.value)} />
                                    {o.label}
                                </MenuItem>
                            ))}
                        </Select>
                        <FormHelperText>{selectInfo}</FormHelperText>
                    </FormControl>
                )}
            />
            <FormError name={name} />
        </div>
    );
};
